import React from 'react';
import { useTranslation } from 'react-i18next';
import ScreenTitle from '../../common/components/screenTitle/ScreenTitle';
import styles from './DownloadAppScreen.module.scss';
import GoogleStore from 'assets/img/google-play-badge-en.png';
import AppleStore from 'assets/img/app-store-en.png';
import { APPLE_STORE_APP_URL, GOOGLE_STORE_APP_URL } from 'Config';

const DownloadAppScreen: React.FC = () => {

    const { t } = useTranslation();

    const handleClick = (isGoogle: boolean) => {
        if (isGoogle) {
            window.open(GOOGLE_STORE_APP_URL, '_blank');

            return;
        }
        window.open(APPLE_STORE_APP_URL, '_blank');
    };
    return (
        <ScreenTitle title={t('common.errors.page_forbidden_title')}>
            <div className={styles.container} >

                <div className={styles.contentContainer} id="scrollHere">
                    <h1>{t('common.errors.page_download_mobile')}:</h1>
                    <div className={styles.iconsContainer}>
                        <div className={styles.img} style={{ width: '10rem', height: '4rem', backgroundImage: 'url(' + GoogleStore + ')' }} onClick={() => { handleClick(true) }} />
                        <div className={`${styles.img} ${styles.leftIcon}`} style={{ width: '10rem', height: '4rem', backgroundImage: 'url(' + AppleStore + ')' }} onClick={() => { handleClick(false) }} />
                    </div>
                </div>


            </div>
        </ScreenTitle>
    );
}

export default DownloadAppScreen;
